(() => {
  const initComparison = (root) => {
    const comparisons = root.querySelectorAll('.custom-before-after-comparison__component');

    comparisons.forEach((comparison) => {
      const range = comparison.querySelector('.custom-before-after-comparison__range');

      if (!range || range.dataset.initialized === 'true') {
        return;
      }

      const updatePosition = () => {
        const value = Math.max(0, Math.min(100, Number(range.value) || 0));

        comparison.style.setProperty('--before-after-position', `${value}%`);
        range.setAttribute('aria-valuetext', `${value}%`);
      };

      range.dataset.initialized = 'true';
      
      range.addEventListener('input', updatePosition);
      updatePosition();
    });
  };

  document.addEventListener('DOMContentLoaded', () => initComparison(document));
  document.addEventListener('shopify:section:load', (event) => initComparison(event.target));
})();
